module.exports = __webpack_public_path__ + "img/sec-banner.8d93fa82.png";